module.exports = __webpack_public_path__ + "static/media/Team 1 Wellee  Eric Zhang.6feb6ec1.png";